import { testTokens } from '@/test/integration/constants'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { zeroAddress } from 'viem'
import { Permit2SignAction } from '../types'

const token = testTokens.DAI

export function getFakePermit2SignAction(): Permit2SignAction {
  return {
    type: 'permit2Sign',
    token,
    amount: NormalizedUnitNumber(0),
    spender: zeroAddress,
  }
}

